var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"last-published-domain-date"},[_vm._v("\n  "+_vm._s(_vm.$t('lastPublishedDomainDate.lastPublished'))+"\n  "+_vm._s(_vm.getHumanDate(_vm.domain.last_published))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }